import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    max-width: 1280px;
    padding: 0px 100px;
    margin: 10px 0px;
    display: flex;
    align-items: end;
    justify-content: flex-end;
    flex-direction: column;
    @media (max-width: 768px) {
        padding: 0px 16px;
        max-width: 100%;
    }
`
